module.exports = __webpack_public_path__ + "img/рз_53.53d2e674.png";